'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchSectionShell } from '../SearchSectionShell';
import { GiftCardSkeletonList } from './GiftCardSkeletonList';
import { GiftFilter } from './GiftFilter';
import { GiftList } from './GiftList';
interface GiftSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  categoryIds: number[];
  institutionIds: number[];
  onToggleCategory: (id: number) => void;
  onToggleInstitution: (id: number) => void;
  onReset: () => void;
}
export function GiftSearch(t0) {
  const $ = _c(29);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter,
    categoryIds,
    institutionIds,
    onToggleCategory,
    onToggleInstitution,
    onReset
  } = t0;
  let t1;
  if ($[0] !== categoryIds || $[1] !== institutionIds || $[2] !== keyword || $[3] !== page) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/gift-products"]({
      query: {
        searchKeyword: keyword,
        categoryIdList: categoryIds.length > 0 ? categoryIds : undefined,
        institutionIdList: institutionIds.length > 0 ? institutionIds : undefined,
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = categoryIds;
    $[1] = institutionIds;
    $[2] = keyword;
    $[3] = page;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount ?? 0;
  let t4;
  if ($[7] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const meta = t4;
  let t5;
  if ($[9] !== categoryIds || $[10] !== institutionIds || $[11] !== isFilterOpen || $[12] !== onCloseFilter || $[13] !== onReset || $[14] !== onToggleCategory || $[15] !== onToggleInstitution) {
    t5 = <GiftFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} categoryIds={categoryIds} institutionIds={institutionIds} onToggleCategory={onToggleCategory} onToggleInstitution={onToggleInstitution} onReset={onReset} />;
    $[9] = categoryIds;
    $[10] = institutionIds;
    $[11] = isFilterOpen;
    $[12] = onCloseFilter;
    $[13] = onReset;
    $[14] = onToggleCategory;
    $[15] = onToggleInstitution;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchSideAdBanner />;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== data?.context?.contents || $[19] !== isLoading) {
    t7 = isLoading ? <GiftCardSkeletonList count={PAGE_SIZE} /> : <GiftList items={data?.context?.contents ?? []} />;
    $[18] = data?.context?.contents;
    $[19] = isLoading;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== meta || $[22] !== onPageChange || $[23] !== page || $[24] !== t7) {
    t8 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t7}</SearchSectionShell>;
    $[21] = meta;
    $[22] = onPageChange;
    $[23] = page;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t5 || $[27] !== t8) {
    t9 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5} rightAside={t6}>{t8}</DesktopPageShell>;
    $[26] = t5;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}